import { useEffect } from "react";

interface SEOHeadProps {
  title: string;
  description: string;
  path: string;
  keywords?: string;
  type?: string;
  jsonLd?: object;
}

const SEOHead = ({ title, description, path, keywords, type = "website", jsonLd }: SEOHeadProps) => {
  const baseUrl = "https://synra-ai.com";
  const fullUrl = `${baseUrl}${path}`;

  useEffect(() => {
    document.title = title;

    const setMeta = (name: string, content: string, attr = "name") => {
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("description", description);
    if (keywords) setMeta("keywords", keywords);
    setMeta("og:title", title, "property");
    setMeta("og:description", description, "property");
    setMeta("og:url", fullUrl, "property");
    setMeta("og:type", type, "property");
    setMeta("twitter:title", title);
    setMeta("twitter:description", description);

    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", fullUrl);

    // Inject page-specific JSON-LD
    let jsonLdScript: HTMLScriptElement | null = null;
    if (jsonLd) {
      jsonLdScript = document.createElement("script");
      jsonLdScript.type = "application/ld+json";
      jsonLdScript.id = "page-jsonld";
      jsonLdScript.textContent = JSON.stringify(jsonLd);
      // Remove existing page-level JSON-LD
      document.querySelector("#page-jsonld")?.remove();
      document.head.appendChild(jsonLdScript);
    }

    return () => {
      document.title = "SYNRA — منصة الذكاء الاصطناعي والأتمتة في المغرب";
      document.querySelector("#page-jsonld")?.remove();
    };
  }, [title, description, fullUrl, type, keywords, jsonLd]);

  return null;
};

export default SEOHead;
